/**
 * Convert the style category and the style name to the `styleName` string.
 * @param {object} styleNameObject
 * @returns {string}
 */
const stringifyStyleName = styleNameObject => {
  return [styleNameObject.category, styleNameObject.name].join('.');
};

export default stringifyStyleName;
